/**
 * The business reason of a failed Edge Function call.
 *
 * `supabase.functions.invoke` turns a non-2xx response into a `FunctionsHttpError` whose
 * message is generic (« Edge Function returned a non-2xx status code »); the JSON body with
 * the Edge's own `error` lives in `error.context`, a `Response`. Read it there so the user
 * sees the real reason (« Otto a posé une autre question depuis… »), else the fallback.
 */
export async function edgeErrorMessage(error: unknown, fallback: string): Promise<string> {
  const context = (error as { context?: unknown } | null)?.context;
  if (context instanceof Response) {
    try {
      const parsed = (await context.json()) as { error?: unknown };
      if (typeof parsed?.error === 'string' && parsed.error.trim()) return parsed.error;
    } catch {
      /* non-JSON body: keep the fallback */
    }
  }
  return fallback;
}
